import React from "react";
import "./cookiesPolicy.scss";
import {Link} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AppFooter from "../../../components/appFooter";


export default function CookiesPolicy(props) {
    return (
        <div className={"mainDiv"}>
            <div className="brand-bg-inverse-color mb-3 fancyFont">
                <div className="container">
                    <nav className="navbar navbar-expand-sm navbar-dark brand-bg-inverse-color">
                        <Link to={"/"} className="navbar-brand">
                            <img src={require("../../../assets/logo.png")} alt="" width={"140px"}/>
                        </Link>

                    </nav>
                </div>
            </div>

            <div className="container fancyFont">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className="h3 brand-text-color inner-header">Cookies Policy</h3>
                    </div>

                    <div className="col-lg-12 mb-5">
                        <p>A browser cookie is a small piece of data that is stored on your device to help websites and
                            mobile apps (“Portal”) remember things about you. Other technologies, including Web storage
                            and identifiers associated with your device, may be used for similar purposes. In this
                            policy, we
                            say “cookies” to discuss all of these technologies.</p>

                        <p>Our Privacy Policy explains how we collect and use information from and about you when you
                            use MenonId.com (“MID”) and certain of our other services such as matrimonial services, job
                            and business opportunities etc (“Services”). This policy explains more about how we use
                            cookies
                            and your related choices.</p>

                        <h6 className="h6">How We Use Cookies</h6>

                        <p>Like most providers of online services, MID uses cookies for a number of reasons, like
                            protecting your MID data and account, helping us see which features are most popular,
                            counting
                            visitors to a page, improving our users’ experience, keeping our Services secure, and just
                            generally providing you with a better, more intuitive, and satisfying experience. The
                            cookies we
                            use generally fall into one of the following categories.</p>

                        <div className="table-responsive">
                            <table className="table">
                                <tbody>
                                <tr>
                                    <th>Category of Cookies</th>
                                    <th>Why we use these cookies</th>
                                </tr>
                                <tr>
                                    <td>Preferences</td>
                                    <td>
                                        We use these cookies to remember your settings and preferences.For example, we
                                        may use these cookies to
                                        remember your language preferences.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Security</td>
                                    <td>We use these cookies to help identify and prevent security risks. For example,
                                        we may use these cookies
                                        to store your session information to prevent others from changing your password
                                        without your username and
                                        password.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Performance</td>
                                    <td>We use these cookies to collect information about how you interact with our
                                        Services and to help us improve them. For example, we may use these cookies to
                                        determine if you have
                                        interacted with a certain page.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Analytics</td>
                                    <td>We use these cookies to help us improve our Services.For example, we can use
                                        these cookies to learn more
                                        about which features are the most popular with our users and which ones might
                                        need some tweaks.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Advertising</td>
                                    <td>We use these cookies to deliver advertisements, to make them more relevant and
                                        meaningful to consumers,
                                        and to track the efficiency of our advertising campaigns, both on our Services
                                        and on other websites or
                                        mobile apps.
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <h6 className="h6">Your Choices</h6>

                        <p>Your browser or device may allow you to block or otherwise limit the use of cookies. But
                            cookies are an important part of how our Services work, so removing, rejecting, or limiting
                            the
                            use of them could affect the availability and functionality of our Services.</p>

                        <h6 className="h6">Browser Cookies</h6>

                        <p>Your browser may provide you with the option to refuse some or all browser cookies. You may
                            also be able to remove cookies from your browser. For more information about how to manage
                            browser cookies, please follow the instructions provided by your browser.</p>

                        <h6 className="h6">Mobile Device Identifiers</h6>

                        <p>Your mobile operating system may let you opt-out from having certain device identifiers used
                            for interest-based advertising. You should refer to the instructions provided by your mobile
                            device’s manufacturer; this information is typically available under the “Settings” function
                            of
                            your mobile device.</p>

                        <p>And of course, if your mobile device offers an uninstall process, you can always stop us from
                            collecting information through the Portal by uninstalling the MID.</p>

                        <h6 className="h6">Contact Us</h6>

                        <p>
                            If you have any questions about our use of cookies, please contact our Customer Support.
                        </p>
                    </div>
                </div>
            </div>
            <AppFooter/>
        </div>

    );
}
